import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import ArticleList from "../article/articleList";
import MultiScanForm from "../MultiScanForm/MultiScanForm";
import Numpad from "../numpad/Numpad";
import { MobileInlineScanner } from "../Scanner/MobileInlineScanner";
import { useActiveSalesWrapStore, useSelectedArticleStore } from "../../store/store";
import { Article, PurchaseOrder, SalesOrderApi, SalesWrap } from "../../api/order/generated/src";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import SalesWrapListItem from "../SalesOrderList/SalesWrapListItem";
import { useSnackbar } from "../snackbar";
import { BsBox } from "react-icons/bs";
import ProgressBar from "../ProgressBar/ProgressBar";
import { getOrderApiConfig } from "../../api-configs/OrderApiConfig";



export interface IBatchItem {
    batch: string;
    booked: number;
}

export interface ISerialnumberItem {
    serial: string
    booked: number;
}

// export interface IArticle {
//     id: string;
//     title: string;
//     booked: number;
//     ordered: number;

//     batchItems?: IBatchItem[]
//     serialItems?: ISerialnumberItem[]
// }

interface ISalesWrapDetailProps {

}

const SalesWrapDetail = (props:ISalesWrapDetailProps) => {
    const { orderId } = useParams();

    const { t } = useTranslation();

    const showSnackbar = useSnackbar();


    // const [salesWrap, setSalesWrap] = useState<SalesWrap>();

    
    const salesWrap = useActiveSalesWrapStore(state => state.salesWrap);
    const setSalesWrap = useActiveSalesWrapStore(state => state.updateActive);

    const setSelectedArticle = useSelectedArticleStore(state => state.updateSelected);
    
    
    useEffect(() => {

        const init = async () => {

            let tmpSalesWrap:SalesWrap|null = null;

            if(orderId){

                try {
                    const salesOrderApi:SalesOrderApi = new SalesOrderApi(getOrderApiConfig());
                    const foundSalesWrap:SalesWrap = await salesOrderApi.getSalesOrder({id:orderId});
        
                    
                    tmpSalesWrap = foundSalesWrap;
                    
                } catch (error) {
                    
                }
                
                
                // if(!tmpSalesWrap){

                //     // dummy
                //     tmpSalesWrap = {
                //         id: "1",
                //         deliveryDate: new Date(Date.parse("11.07.2025 11:05")),
                //         pickingDate: new Date(Date.parse("11.07.2025 11:05")),
                //         annotation: "Notiz",
                //         status: "PARTIALLY-DELIVERED",
                       
                //         customer: {
                //             id: "1",
                //             name: "Max Muster"
                //         },
                //         quantity: 10,
                //         quantityBooked: 3,
            
                //         articles: [
                //             {
                //                 id: "1",
                //                 externalId: "NS0156.525",
                //                 title: "rund/round - 6,0mm - 14 Schneiden/flutes - Hilan XS - II",
                //                 quantityBooked: 1,
                //                 quantity: 4
                //             },
                //             {
                //                 id: "2",
                //                 externalId: "ND0134.009",
                //                 title: "rund-3,5mm-medium",
                //                 quantityBooked: 1,
                //                 quantity: 2,
                //                 batchItems: [
                //                     {
                //                         batch: "090166",
                //                         quantityBooked: 1,
                //                         bestBefore: new Date(Date.parse("11.07.2026 11:05")),
                //                         productionDate: new Date(Date.parse("11.06.2025 11:05")),
                //                     },
                //                     {
                //                         batch: "090166x",
                //                         quantityBooked: 0,
                //                         bestBefore: new Date(Date.parse("11.07.2026 11:05")),
                //                         productionDate: new Date(Date.parse("11.06.2025 11:05")),
                //                     }
                //                 ]
                //             },
                //             {
                //                 id: "3",
                //                 externalId: "ND0146.009",
                //                 title: "rund-1,8mm-medium",
                //                 quantityBooked: 0,
                //                 quantity: 1
                //             },
                //             {
                //                 id: "4",
                //                 externalId: "ND0190.009",
                //                 title: "rund/round - 2,7mm - medium",
                //                 quantityBooked: 2,
                //                 quantity: 3,
                //                 serialItems: [
                //                     {
                //                         serial: "0815",
                //                         quantityBooked: 1
                //                     },
                //                     {
                //                         serial: "0816",
                //                         quantityBooked: 1
                //                     }
                //                 ]
                //             }
                //         ]
                            
                        
                //     }
                // }
    

                if(tmpSalesWrap){
                    setSalesWrap(tmpSalesWrap);
                }
        
        
            }
        }

        init();



    }, [orderId, setSalesWrap]);

    const checkScan = useCallback(async (scanned:string) => {
        // hier ID aus Scan ermitteln

        return scanned;

        // return null;
    }, []);
    
    const runSearch = useCallback(async (id:string) => {


        if(orderId){
            const salesOrderApi:SalesOrderApi = new SalesOrderApi(getOrderApiConfig());

            let newSalesWrap:SalesWrap|null = null;
    
            try {
                // const newSalesWrap = await salesOrderApi.incrementArticleAmount({id:orderId, });
                const tmpSalesWrap = await salesOrderApi.getSalesOrderScan({id:orderId, scanned:id});

                newSalesWrap = tmpSalesWrap;
                
                
            } catch (error) {
                
            }    
            
            
            // // fake it til u make it 
            // if(!newSalesWrap){
            //     newSalesWrap = {...salesWrap};

            //     newSalesWrap.quantityBooked = (newSalesWrap.quantityBooked ?? 0) + 1;

            //     const x = newSalesWrap?.articles?.find(() => true);
            //     if(x){
            //         x.quantityBooked = (x.quantityBooked ?? 0) + 1;
            //     }

            // }

            if(newSalesWrap){
                setSalesWrap(newSalesWrap);

                if(newSalesWrap.lastSelected){
                    if(newSalesWrap.lastSelected.articleId){
                        setSelectedArticle(newSalesWrap.lastSelected.articleId, (newSalesWrap.lastSelected.batch ?? newSalesWrap.lastSelected.serial ?? ""));
                    }
                }


                showSnackbar(t("common:sales.Orders.addByScan.success"), 'success', 2000);
            }


        }

        


        // const articles = salesWrap.
        
        // try {
        //     // hier die Suche anhand der ID ausführen und weiterleiten


        //     // dummy ... erstmal den ersten verwenden, bis Api steht
        //     const changed = articles?.find((itm) => {
        //         return itm.id === id;
        //     });

        //     if(changed != null && changed.id != null){
                
        //         setSelectedArticle(changed.id, changed.batchItems?.[0]?.batch ?? "");

        //         setLastChanged(changed);
    
        //         // setShowNumpad(true);
        //     }


            
        // } catch (error) {
        //     console.log(error);
            
        // }

        return false;
    }, [orderId, salesWrap, setSalesWrap, showSnackbar, t]);



    const handleOutgoingGood = useCallback(async () => {
        if(orderId){
            let newSalesWrap:SalesWrap|null = null;

            const salesOrderApi:SalesOrderApi = new SalesOrderApi(getOrderApiConfig());
            try {

                const tmpSalesWrap = await salesOrderApi.confirmSalesWrap({id:orderId});

                newSalesWrap = tmpSalesWrap;

            } catch (error) {

            }    

            // fake it til u make it 
            if(!newSalesWrap){
                newSalesWrap = {...salesWrap};


            }


            if(newSalesWrap){
                setSalesWrap(newSalesWrap);
            }
        }
    }, [orderId, salesWrap, setSalesWrap]);
    
    
    const totalProgress = salesWrap.quantityBooked ?? 0;
    const totalTarget = salesWrap.quantity ?? 0;
    const progressPercent = Math.min(((totalProgress / totalTarget) * 100), 100);


    return (

        <div className="min-h-screen max-w-7xl mx-auto">

            <div className="min-h-screen bg-gray-50 flex flex-col">

                {/* <div className="text-3xl mb-4">
                    {t("common:salesordersdetail.header")}
                </div>
                <div className="text-xl mb-4">
                    {t("common:salesordersdetail.description")}
                </div> */}

                <div className="bg-white shadow-sm border-b">
                    <div className="p-4">
                        <div className="flex items-start justify-between mb-3">
                            <h1 className="text-lg font-semibold text-gray-900 flex flex-row flex-wrap gap-2">
                                <span>
                                    {t("common:salesordersdetail.header")}:
                                </span>
                                <span className="text-lg text-gray-900 self-end">{salesWrap.id}</span>
                            </h1>
                            
                            <div className="flex items-center space-x-2 text-sm text-gray-600">
                                <BsBox className="w-4 h-4" />
                                <span>{totalProgress}/{totalTarget}</span>
                            </div>
                        </div>

                        <ProgressBar 
                            totalProgress={totalProgress}
                            totalTarget={totalTarget}
                        />

                        <div className="mb-4">
                            <MultiScanForm 
                                checkScan={checkScan}
                                runSearch={runSearch}

                                inputLabel={t("common:scanPlaceholder.salesArticle") ?? ""}
                            />

                        </div>

                    </div>
                </div>






                {/* <div className="w-full flex justify-center align-center">
                    <MobileInlineScanner />
                </div> */}

                {/* bg-white rounded-b-lg */}
                <div className="flex-1 min-h-0 overflow-y-auto  mb-4">
                    { salesWrap != null && 
                        
                        <SalesWrapListItem item={salesWrap} noLink={true} />

                    }
                </div>

                {/* <div className="flex justify-end">
                    <Button 
                        className="flex-1 bg-blue-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2"
                        variant="contained" 
                        color="primary" 
                        onClick={() => { 
                            handleOutgoingGood();
                        }}
                    >
                        {t("common:confirmOutgoingGoods")}
                    </Button>
                </div> */}

                <div className="fixed bottom-0 left-0 right-0 bg-white border-t p-4 h-24 max-w-7xl mx-auto">
                    <div className="flex space-x-3 justify-center">
                        <Button 
                            className="bg-blue-600 text-white py-3 !px-8 rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2"
                            variant="contained" 
                            color="primary" 
                            onClick={() => { 
                                handleOutgoingGood();
                            }}
                        >
                            {t("common:confirmOutgoingGoods")}
                        </Button>
                    </div>

                    <div className="mt-2 text-center">
                        <p className="text-sm text-gray-500">
                            {t("common:sales_statusline", {
                                totalProgress: totalProgress, 
                                totalTarget: totalTarget, 
                                percent: Math.round(progressPercent)
                            })}

                            {/* {totalProgress} von {totalTarget} Artikeln erfasst ({Math.round(progressPercent)}%) */}
                        </p>
                    </div>

                </div>
                <div className="h-24"></div>

                
            </div>
        </div>

      
    )
};

export default SalesWrapDetail;
